import api from './api'
import type {
  CheckProcessedResponse,
  EmailSearchRequest,
  EmailSearchResponse,
  EmailSearchResult,
  ProcessEmailsRequest,
  ProcessEmailsResponse,
} from '@/types/emailSearch'

function cleanSearchRequest(data: EmailSearchRequest): Record<string, unknown> {
  const cleaned: Record<string, unknown> = {}
  
  for (const [key, value] of Object.entries(data)) {
    if (value !== '' && value !== undefined && value !== null) {
      cleaned[key] = value
    }
  }
  
  return cleaned
}

export async function searchEmails(data: EmailSearchRequest): Promise<EmailSearchResponse> {
  const cleaned = cleanSearchRequest(data)
  const response = await api.post<EmailSearchResponse>('/email-search/search', cleaned)
  return response.data
}

export async function processEmails(emails: EmailSearchResult[]): Promise<ProcessEmailsResponse> {
  const request: ProcessEmailsRequest = {
    emails: emails.map(e => ({
      gmail_id: e.gmail_id,
      inbox: e.inbox,
      ...(e.email_rule_id != null ? { email_rule_id: e.email_rule_id } : {}),
    })),
  }
  const response = await api.post<ProcessEmailsResponse>('/email-search/process', request)
  return response.data
}

export async function processSingleEmail(email: EmailSearchResult): Promise<ProcessEmailsResponse> {
  const request: ProcessEmailsRequest = {
    emails: [{
      gmail_id: email.gmail_id,
      inbox: email.inbox,
      ...(email.email_rule_id != null ? { email_rule_id: email.email_rule_id } : {}),
    }],
  }
  const response = await api.post<ProcessEmailsResponse>('/email-search/process', request)
  return response.data
}

export async function checkProcessedEmails(messageIds: string[]): Promise<CheckProcessedResponse> {
  const response = await api.post<CheckProcessedResponse>('/email-search/check-processed', {
    message_ids: messageIds,
  })
  return response.data
}
